import { useSelect } from '@refinedev/antd';
import { Select } from 'antd';
import { BaseRecord, CrudFilters } from '@refinedev/core';
import { SelectProps } from 'antd/es/select';

type Props<T> = {
  resource: string;
  optionLabel: keyof T extends string ? string & keyof T : never;
  id?: string;
  label: string;
  filters?: CrudFilters;
} & SelectProps;

export const ReferenceSelect = <T extends BaseRecord>({
  resource,
  optionLabel,
  label,
  filters,
  ...props
}: Props<T>) => {
  const { selectProps } = useSelect<T>({
    resource,
    optionLabel,
    filters,
    optionValue: 'id' as keyof T extends string ? string & keyof T : never,
    meta: {
      fields: ['id', optionLabel],
    },
    onSearch: (value) => [
      {
        field: optionLabel,
        operator: 'contains',
        value,
      },
    ],
  });

  return (
    <Select showSearch id={props.id} placeholder={`${label}を選択`} {...selectProps} {...props} />
  );
};
